import { Badge } from '@/components/ui/Badge';
import useAnalytics from '@/lib/analytics/useAnalytics';
import {
  BookIcon,
  CircleHelp,
  Command,
  FormInput,
  Mail,
  MessageSquare,
} from 'lucide-react';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import SidebarItem from '../Sidebars/SidebarItem';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/DropdownMenu';

const HelpMenu = () => {
  const router = useRouter();
  const { track } = useAnalytics();

  const navLinks = [
    {
      label: 'Writing prompts',
      header: 'No Link',
      link: '/docs/chat/writing-prompts',
      isExternal: true,
      icon: <FormInput size={14} className="text-muted-foreground2" />,
    },
    {
      label: 'Keyboard shortcuts',
      header: 'No Link',
      link: '/docs/user-interface/keyboard-shortcuts',
      isExternal: true,
      icon: <Command size={14} className="text-muted-foreground2" />,
    },
    {
      label: 'User guide',
      header: 'No Link',
      link: '/docs',
      isExternal: true,
      icon: <BookIcon size={14} className="text-muted-foreground2" />,
      isNew: true,
    },
    {
      label: 'Email support',
      link: 'mailto:support@anara.com',
      icon: <Mail size={14} className="text-muted-foreground2" />,
    },
    {
      label: 'Talk to a person',
      id: 'intercom_support',
      link: '#',
      icon: <MessageSquare size={14} className="text-muted-foreground2" />,
    },
  ];

  const handleLinkClick = (link: {
    link: string;
    label: string;
    isExternal?: boolean;
  }) => {
    if (!link) return;
    if (link.isExternal) {
      window.open(link.link, '_blank');
    } else {
      if (typeof link.link === 'string') {
        router.push(link.link);
      } else {
        console.error('Invalid link:', link.link);
      }
    }
    track('supportLinkClicked', { variant: link.label });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SidebarItem icon={CircleHelp}>Support</SidebarItem>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[244px]">
        {navLinks.map((link, index) => (
          <Fragment
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            key={index}
          >
            <DropdownMenuItem
              {...(link.label === 'Talk to a person' && {
                id: 'intercom_support',
              })}
              onSelect={() => handleLinkClick(link)}
              className="px-1.5 py-1 text-sm flex flex-row items-center w-full justify-start gap-1.5 rounded-md hover:bg-elementGray2 cursor-pointer font-medium"
            >
              {link.icon}
              {link.label}
              {link.isNew && <Badge variant="new">NEW</Badge>}
            </DropdownMenuItem>
            {index === 2 && <DropdownMenuSeparator />}
          </Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default HelpMenu;
